<div
  class="w-full search-container d-flex fl-al-center fl-justify-between"
  [ngClass]="{
    'h-fit': isDiscoveryContentTemplate || isFromLinkedTemplate,
    '!pr-0': removedRightPadding,
    'p-0': isInputFullWidth || isDiscoveryContentTemplate || isFromLinkedTemplate,
    'pr-0': isbalanceSheetOwner
  }"
>
  <div class="form-group form-main form-group-overrides width-100per mb-0">
    <div class="div-group width-100per">
      <mat-form-field
        appearance="fill"
        id="access-manager-matAutoComplete"
        matTooltipClass="add-member-tooltip"
        [ngClass]="{
          'disable-search': disableSearch,
          'white-background': isInputFocused,
          'temp-alignment': !isInputFocused,
          'w-full': isInputFullWidth
        }"
      >
        <div matPrefix class="mr-2 matPrefix-search-icon flex-center">
          <img src="../../../../assets/images/search-blue.svg" width="20px" height="19px" />
        </div>

        <input
          #inputField
          type="text"
          matInput
          aria-label="Number"
          [disabled]="disableSearch"
          [formControl]="connectionUserFormControl"
          [matAutocomplete]="auto"
          [placeholder]="placeHolder"
          class="addMember global-input text-base font-sans font-normal text-[#53565B]"
          [ngClass]="{ 'text-[#53565B66]': disableSearch }"
          (input)="onTrustSearch($event.target.value)"
          (focus)="onInputFocus()"
          (blur)="onInputBlur()"
        />

        <div *ngIf="connectionUserFormControl.value && !isComboInput" matSuffix (click)="onClearInput()">
          <mat-icon class="close-input-icon mr-4">close</mat-icon>
        </div>

        <div *ngIf="isInputFocused && isComboInput" matSuffix (click)="onClearInput()">
          <mat-icon class="close-input-icon mr-4">close</mat-icon>
        </div>

        <mat-autocomplete #auto="matAutocomplete" class="search-scroll-main template-Search">
          <div>
            <ng-container>
              <div class="width-100per">
                <mat-option class="h-fit" *ngIf="(data | addFilterReportDataList : selectedTemplate : connectionUserFormControl.value)?.length == 0">
                  <div class="flex gap-4 py-5 h-fit fl-al-center">
                    <div class="flex" style="height: 84px; width: 84px">
                      <img src="assets/images/no-matchin-result.svg" />
                    </div>
                    <div style="color: #18191c">
                      <div class="font-semibold text-[#18191C]" style="font-size: 22px; margin-bottom: 8px; line-height: 24px">
                        No matching results to show
                      </div>
                      <div class="text-sm font-normal text-[#18191C]">Try changing the search terms, or add a new template</div>
                    </div>
                  </div>
                </mat-option>

                <div *ngIf="(data | addFilterReportDataList : selectedTemplate : connectionUserFormControl.value)?.length != 0">
                  <div class="search-list-overflow">
                    <div>
                      <mat-option
                        class="search-list-box"
                        *ngFor="let entity of data | addFilterReportDataList : selectedTemplate : connectionUserFormControl.value; let i = index"
                        (onSelectionChange)="selectConnectedUser(entity)"
                      >
                        <div class="d-flex fl-justify-between fl-al-center">
                          <div class="d-flex fl-al-center gap-3">
                            <div>
                              @if(entity.key_path){
                              <img class="back-avatar-grup rounded bg-[#f1f1f1] p-1" [src]="entity.key_path" *ngIf="!entity?.profile_image_url" />
                              }@else{
                              <img class="back-avatar-grup" src="assets/images/avtar-trust.svg" *ngIf="!entity?.profile_image_url" />

                              }
                              <img class="back-avatar-grup" src="{{ entity?.profile_image_url }}" *ngIf="entity?.profile_image_url" />
                              <!-- <ngx-avatars *ngIf="entity?.profile_image_url" size="32" src="{{entity?.profile_image_url}}"
                                name="{{ entity?.form_name }}" [round]="true" initialsSize="2"></ngx-avatars> -->
                            </div>

                            <div>
                              <div class="text-sm font-normal font-sans color-[#18191C]">{{ entity?.form_name }}</div>
                              <div class="text-[10px] leading-3 font-normal font-sans color-[#707070]">{{ entity?.type }}</div>
                            </div>
                          </div>

                          <div class="d-flex fl-al-center gap-2">
                            @if((entity?.owner_userid || entity?.owner_entityid) && entity?.net_amount !== null && entity?.net_amount !== undefined){
                            <div class="d-flex fl-al-center gap-2">
                              <span matTooltip="{{ entity?.owner_name }}">
                                <ngx-avatars
                                  size="24"
                                  [src]="entity?.owner_profile_image_url"
                                  [name]="entity?.owner_name"
                                  [round]="true"
                                  initialsSize="2"
                                  cornerRadius="100"
                                ></ngx-avatars>
                              </span>

                              <span class="position-tag"> {{ entity?.net_amount | number : '1.0-0' }}% </span>
                            </div>
                            }
                            <span
                              class="app__form--attribute--title text-sm"
                              *ngIf="entity?.position_value !== null && entity?.position_value !== undefined && isPositionValueShown"
                            >
                              {{ entity?.position_value | currency : 'USD' : 'symbol' : '1.0-2' }}
                            </span>
                          </div>
                        </div>
                      </mat-option>
                    </div>
                  </div>
                </div>

                <!-- <div [ngClass]="'grid-cols-' + (templateConfigurationList.length > 1 ? templateConfigurationList.length : '')"  class="footer-container grid gap-3 p-4" *ngIf="templateConfigurationList.length > 0"> -->
                <div
                  [ngClass]="'grid-cols-' + templateConfigurationList.length + ' grid gap-3'"
                  class="footer-container p-4"
                  *ngIf="templateConfigurationList.length > 0 && isShowFooter"
                >
                  <mat-option class="footer-menu" (click)="addNewTemplate(item)" *ngFor="let item of templateConfigurationList">
                    <div class="flex flex-col justify-center items-center w-full">
                      <div class="flex-center h-[40px] w-[40px]">
                        <!-- <img src="assets/images/footer-profit.svg" /> -->
                        <img
                          class="h-full w-full"
                          [src]="
                            origin == 'location' || item.isCustomImg
                              ? item?.img
                              : item?.img
                              ? 'assets/images/discovery/' + item?.img + '.svg'
                              : 'assets/images/shared.svg'
                          "
                        />
                      </div>
                      <div class="template-text" appTooltip [toolTipText]="item?.displayType ? item?.displayType : item.label">
                        {{ item?.displayType ? item?.displayType : item.label }}
                      </div>
                    </div>
                  </mat-option>
                </div>
              </div>

              <!-- *ngIf="loader$ | async" -->
              <mat-option *ngIf="loader" class="h-fit">
                <div class="search-box-container">
                  <div class="loader-container grid grid-cols-7 p-4 pb-0">
                    <div class="width-100per" *ngFor="let item of loaderItems">
                      <div class="width-100per" id="{{ item.id }}">
                        <div class="ph-item width-100per content__loader" style="padding: 0px; margin: 0px; border: none">
                          <div class="ph-col-12" style="padding: 0px !important; margin: 0px">
                            <div class="ph-row">
                              <div class="ph-col-12" style="height: 96px; border-radius: 4px; max-width: 100px"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr style="margin: 0px" />
                  <div class="loader-container grid grid-cols-3 p-4 gap-2 pb-0">
                    <div class="width-100per" *ngFor="let item of loaderItems | slice : 0 : 3">
                      <div class="width-100per" id="{{ item.id }}">
                        <div class="ph-item width-100per content__loader" style="padding: 0px; margin: 0px; border: none">
                          <div class="ph-col-12" style="padding: 0px !important; margin: 0px">
                            <div class="ph-row">
                              <div class="ph-col-12" style="height: 94px; border-radius: 4px; max-width: 256px"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-option>
            </ng-container>
          </div>
        </mat-autocomplete>
      </mat-form-field>
    </div>
  </div>
</div>
